<template>
	<div class="xs-12">
		<j-base-multi-select-with-flexible-value
			:id="id"
			:options="filteredOptions"
			:value="value"
			:placeholder="placeholder ? placeholder : $t('search_name_code')"
			:allowLocalSearch="false"
			:allowMultiselect="allowMultiselect"
			:status="status"
			:isLoading="isLoading"
			:size="size"
			valueKey="code"
			nameKey="name"
			@input="onInput($event)"
			@search="onSearch($event)"
		/>
	</div>
</template>

<script>
/**
 * This component is responsible for fetching general codes for claims
 */
import JBaseMultiSelectWithFlexibleValue from "@/components/JBaseMultiSelectWithFlexibleValue"
import api from "../api/"
import debounce from "lodash.debounce"

export default {
	components: { JBaseMultiSelectWithFlexibleValue },
	props: {
		productId: {
			type: Object,
			required: true,
			default: () => ({
				plan: null,
				type: null,
				version: null
			})
		},
		value: {
			validator(value) {
				return value === null || value instanceof Array
			},
			required: true,
			default: () => []
		},
		/**
		 * Name of codes to fetch from api
		 */
		codeName: {
			validator(val) {
				return ["operationSettings", "diagnosisSettings"].includes(val)
			},
			type: String,
			required: true
		},
		id: {
			type: String,
			required: false
		},
		status: {
			type: String,
			required: false
		},
		size: {
			type: String,
			required: false,
			default: "medium"
		},
		placeholder: {
			type: String,
			default: null
		},
		allowMultiselect: {
			type: Boolean,
			default: true
		}
	},

	data() {
		return {
			options: [],
			filteredOptions: [],
			isLoading: false
		}
	},

	methods: {
		onInput(value) {
			this.$emit("input", value)
		},

		// NOTE: Using filter here because there is many items and it has consequences on DOM speed
		// when using search of the multi select component directly
		onSearch: debounce(function(searchTerm) {
			if (!searchTerm) {
				this.filteredOptions = []
				return
			}

			const regex = new RegExp(searchTerm, "gi")
			this.filteredOptions = this.options.filter(
				item =>
					regex.test(item.code) ||
					regex.test(item.name) ||
					regex.test(item.description)
			)
		}, 400),

		async fetchOptions() {
			// Construs api key for boolean flag for GraphQl directive, e.g. hasOperationSettings
			let apiKey = `has${this.codeName
				.charAt(0)
				.toUpperCase()}${this.codeName.slice(1)}`

			// Fetch
			this.isLoading = true
			const res = await api.generalCodes({
				where: { productId: this.productId },
				[apiKey]: true
			})
			this.isLoading = false

			// Adjust data
			const codeNames =
				res?.data?.products?.list?.[0]?.claimSettings?.[this.codeName]
					?.codeNames || []

			this.options =
				codeNames.map(item => ({
					name: `${item.code} - ${item.name}`,
					code: item.code
				})) || []
		}
	},

	created() {},

	watch: {
		productId: {
			handler() {
				// When productId changes, refetch options
				this.fetchOptions()
			},
			deep: true,
			immediate: true
		}
	}
}
</script>
